import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import mdToHtml from '../utils/mdToHtml';

import { Button } from 'components';
import faqContent from "cms/content/teeth-straightening-comparator-faqs.yml";

const SectionTopics = ({ className, locale }) => {

  const [active, toggleTopic] = useState(null);

  if(!faqContent.enabled) return false;

  return (
    <>
    <p className='t-center mb-40'><b>Pick a topic or just scroll down to find out more.</b></p>
    <div className={cx('section-topics', [className])}>
      <div id='focus-topics' className='cta-backtop-target' />
      <div className='topics-wrapper'>
        {faqContent.topics.map( (item, idx) => {
          return (
            <Button label={item['topic']} level='outline' onClick={() => toggleTopic(idx)} key={idx} />
          )
        })}
      </div>

      {faqContent.topics.map( (item, idx) => (
        <div key={idx} className={cx('topic-wrapper', { 'hide': active !== idx })}>
          {item['faqs'].map( ({ question, answerUk, answerEn, answerSe }, idx) => {
            return (
              <Fragment key={idx}>
                <div className='topic-question'><div className='shape' /><p><b>{question}</b></p></div>
                <div className='topic-answer'><div className='shape' />
                  {answerUk && locale === 'uk' ? <div dangerouslySetInnerHTML={{ __html: mdToHtml(answerUk) }} /> : '' }
                  {answerEn && locale === 'en' ? <div dangerouslySetInnerHTML={{ __html: mdToHtml(answerEn) }} /> : '' }
                  {answerSe && locale === 'se' ? <div dangerouslySetInnerHTML={{ __html: mdToHtml(answerSe) }} /> : '' }
                  {!answerEn && !answerSe && locale !== 'uk' ? <div dangerouslySetInnerHTML={{ __html: mdToHtml(answerUk) }} /> : '' }
                </div>
              </Fragment>
            )
          })}
        </div>
      ))}
      {active !== null && <a href='#focus-topics' className='cta-backtop'>back to top</a>}
    </div>
    </>
  );
};

SectionTopics.propTypes = {
  className: PropTypes.string.isRequired,
};

SectionTopics.defaultProps = {
  className: '',
};

export default SectionTopics;
